/**
 * Holds all subjects that the actions can be done on
 */
export enum Subject {
	ADMIN_PANEL = 'ADMIN_PANEL',
	PRODUCTION_PANEL = 'PRODUCTION_PANEL',
}

// eslint-disable-next-line prettier/prettier
export type SubjectType = `${Subject}`;
